<cdk-accordion>
  <cdk-accordion-item #accordionItem="cdkAccordionItem">
    <div class="flex flex-col border divide-y rounded-xl">
      <button
        (click)="accordionItem.toggle()"
        class="flex items-center justify-between w-full p-5 xl:p-6"
      >
        @if (label(); as label) {
          <p class="text-base font-semibold text-gray-800">
            {{ label }}
          </p>
        } @else {
          <ng-content select="[label]" />
        }

        <app-icon
          name="material-symbols:keyboard-arrow-up-rounded"
          [class.rotate-180]="!accordionItem.expanded"
          class="text-gray-800 transition-all duration-300 ease-in-out cursor-pointer hover:opacity-80"
        />
      </button>
      <div
        class="flex flex-col w-full gap-6 p-5 xl:p-6"
        [style.display]="accordionItem.expanded ? '' : 'none'"
      >
        <ng-content />
      </div>
    </div>
  </cdk-accordion-item>
</cdk-accordion>
